import type { VendorProductReviewItem, VendorProductReviewState } from '../../lib/adminApiClient';

export const STATES: VendorProductReviewState[] = ['pending', 'returned'];

export const STATE_LABEL: Record<VendorProductReviewState, string> = {
  pending: 'Pending',
  returned: 'Sent back',
};

export const NOTE_MAX = 1000;

export function readState(raw: string | null): VendorProductReviewState {
  return STATES.includes(raw as VendorProductReviewState) ? (raw as VendorProductReviewState) : 'pending';
}

export function kindLabel(kind: VendorProductReviewItem['kind']): string {
  return kind === 'matched' ? 'Matched to our product' : 'New product';
}

export function noteProblem(note: string): string | null {
  const t = note.trim();
  if (!t) return 'Tell the vendor what to fix.';
  if (t.length > NOTE_MAX) return `Keep it under ${NOTE_MAX} characters.`;
  return null;
}

export function sentBarcode(sent: VendorProductReviewItem['sent']): string | null {
  if (!sent) return null;
  if (sent.barcode) return sent.barcode;
  return sent.noBarcode ? 'No barcode' : null;
}

export function errorMessage(code: string | undefined, fallback: string): string {
  if (code === 'product_not_found') return 'This product no longer exists.';
  if (code === 'not_waiting_for_review') return 'Someone already decided this product.';
  return fallback;
}

export function itemTitle(item: VendorProductReviewItem): string {
  return item.sent?.name || item.product.name;
}
